export default "__VITE_ASSET__2xr1QI0K__"